import { getBackendUrl } from "../config";

export async function fetchVistageGroupCompanies() {
  const backendUrl = getBackendUrl();
  const response = await fetch(`${backendUrl}/api/vistage-group-companies`, {
    cache: "no-store",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || "טעינת הלוגואים נכשלה");
  }
  return Array.isArray(data.items) ? data.items : [];
}
